import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { TPagination } from "@custom-types/sorting";
import { environment } from "@env/environment";
import { Client, TClientsPaginated } from "@models/client.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class IntermediaryService {
  constructor(private readonly http: HttpClient) {}

  getIntermediary$(
    intermediaryId?: string,
    // Not sent yet; see the note below.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchTerm?: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    pagination?: Partial<TPagination>
  ): Observable<Array<Client> | TClientsPaginated> {
    // Keep the current parameters until the backend implementation is finished.
    const params = {
      skip: 0,
      startFrom: new Date().toISOString(),
      take: 10,
    };

    return this.http.get<Array<Client> | TClientsPaginated>(
      `${environment.BASE_URL}intermediary/${intermediaryId}/client`,
      { params }
    );
  }
}
